export default "__VITE_ASSET__3f39360f__"